// 专属报告步骤引擎（从 beauty-report-sample 抽出，供正式 app 复用）
// 固定 9 步骨架 + 动态文案（emphasisOverride 优先，SCENES 兜底）
const SCENES = {
  '日常通勤': {
    tag: '快速出门 · 原生感',
    emphasis: {
      base: '轻薄为主，T 区控油即可',
      eye: '只打底消肿，不画眼线',
      lip: '润色收尾，不强调',
      finish: '一次定妆足矣',
    },
  },
  '约会': {
    tag: '亲和力 · 气色提升',
    emphasis: {
      base: '轻薄 + 局部补光，显白不厚重',
      eye: '眼尾微加深 + 珠光提亮，显温柔',
      lip: '主视觉，温柔浆果色',
      finish: '重点补 T 区，保持清爽',
    },
  },
  '晚宴': {
    tag: '立体感 · 气场全开',
    emphasis: {
      base: '全脸均匀 + 缎光高光，立体通透',
      eye: '完整眼妆 + 眼线睫毛，放大双眼',
      lip: '浓郁正红 / 梅紫，视觉焦点',
      finish: '全脸喷雾锁妆 + 备补妆包',
    },
  },
  '拍照': {
    tag: '上镜感 · 立体饱满',
    emphasis: {
      base: '哑光底 + 高光提立体，抗镜头吃妆',
      eye: '眼线 + 睫毛 + 珠光卧蚕，显精神',
      lip: '饱满咬唇 / 嘟嘟唇，上镜显气色',
      finish: 'T 区强力定妆，防反光',
    },
  },
}

// 场景兜底：未知/动态 scenario（如"今日妆容"）一律回落到 日常通勤 的 emphasis，
// 防止 detailEngine 读 SCENES[scene].emphasis 时因 scene 缺失抛异常导致整页错误边界。
function sceneEmphasis(scene) {
  return (SCENES[scene] || SCENES['日常通勤']).emphasis;
}

const STEP_FRAME = [
  // 阶段一 · 伪素颜
  { no: '01', phase: 1, name: '妆前保养', time: '3 分钟', difficulty: '低', dim: 'base', group: 'skincare' },
  { no: '02', phase: 1, name: '防晒与局部校色', time: '2 分钟', difficulty: '中', dim: 'base', group: 'primer' },
  { no: '03', phase: 1, name: '轻薄底妆 + 精准遮瑕', time: '3 分钟', difficulty: '中', dim: 'base', group: 'base' },
  { no: '04', phase: 1, name: '局部定妆 + 原生眉', time: '2 分钟', difficulty: '低', dim: 'brow', group: 'brow' },
  { no: '05', phase: 1, name: '气色点缀（眼腮唇）', time: '2 分钟', difficulty: '低', dim: 'nude', group: 'nude-lip' },
  // 阶段二 · 进阶
  { no: '06', phase: 2, name: '眼妆进阶', time: '3 分钟', difficulty: '中', dim: 'eye', group: 'eye' },
  { no: '07', phase: 2, name: '精致眼线 + 太阳花睫毛', time: '3 分钟', difficulty: '高', dim: 'eye', group: 'liner' },
  { no: '08', phase: 2, name: '重塑面部轮廓', time: '2 分钟', difficulty: '中', dim: 'contour', group: 'contour' },
  { no: '09', phase: 2, name: '惊艳唇妆 + 二次定妆', time: '2 分钟', difficulty: '中', dim: 'lip', group: 'red-lip' },
]


const detailEngine = {
  '01': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '洗脸后用化妆水拍打全脸唤醒，涂 1 层清爽精华，重点照顾鼻翼、嘴角易脱皮处。',
        p.skinType === '油皮' ? '选清爽乳液（黄豆大小），全脸顺毛孔方向推开。' : p.skinType === '干皮' ? '选滋润面霜（黄豆大小），两颊多加半颗。' : `你是${p.skinType}：T 区用清爽乳液，两颊用保湿面霜，分区护理。`,
      ],
      avoid: [
        '刚擦完护肤品黏糊糊时绝不能立刻上粉底，必须手背摸到「微干、只润不黏」再继续，否则必搓泥（通常等 1-2 分钟）。',
      ],
      focus: (p.emphasisOverride && p.emphasisOverride[stepNo]) || em.base,
    }
  },
  '02': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '选成膜快、不油腻的防晒，顺一个方向涂开，不要反复揉搓。',
        '鼻翼泛红 / 红痘印 → 绿豆大小的绿色隔离点涂拍开；嘴角暗沉 / 黑眼圈 → 紫色或暗桔色隔离局部提亮。',
      ],
      avoid: [
        '彩色隔离只点涂有瑕疵处，绿色隔离全脸涂会让整张脸发青发灰，像生病。',
        p.undertone === '冷调' ? '冷调肤色优先紫色隔离，绿色仅用于明显泛红处。' : '暖调肤色绿色隔离中和更好，别用紫色。',
      ],
      focus: em.base,
    }
  },
  '03': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    const shade = p.undertone === '冷调' ? '10N 冷调' : '10W 暖调'
    return {
      detail: [
        `选与脖子肤色一致的轻薄粉底（${shade}），挤出半泵在手背揉开。`,
        '用手指蘸粉底，从面颊内侧向外轻点；美妆蛋浸湿后吸干八成水，用「盖章」式垂直拍打由内向外拍匀，脸颊边缘用余粉带过。',
        '顽固黑眼圈 / 痘印用遮瑕膏点中心，只晕染边缘与粉底融合。',
      ],
      avoid: [
        '额头、发际线、下颌线粉底过厚会像戴面具；面中（迎光面）亮且无瑕、面周（阴影面）轻薄才有立体感。',
        scene === '拍照' ? '拍照需哑光底抗镜头吃妆，T 区多按一层散粉。' : '日常保留两颊微光泽，别全脸哑光。',
      ],
      focus: em.base,
    }
  },
  '04': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '透明散粉先在手背揉匀防结块，重点按压 T 区、鼻翼、眼周易出油处，两颊轻带保留微光泽。',
        '螺旋刷顺毛流梳理，选比发色浅一号的眉笔，只在稀疏空隙处顺毛流画细线，不要填满。',
      ],
      avoid: [
        '两颊别大量压粉盖成全哑光，会失去裸妆透亮感还显干纹；T 区才是定妆重点。',
      ],
      focus: (p.emphasisOverride && p.emphasisOverride[stepNo]) || em.finish,
    }
  },
  '05': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '粉白 / 杏色 / 浅大地色眼影用大号刷抖掉余粉，在上眼皮大面积平铺，消肿 + 让眼皮干净。',
        '低饱和肉粉 / 杏色腮红用松散刷从苹果肌最高点向太阳穴轻扫。',
        '擦掉护肤润唇膏，换润泽质地的' + p.lipPref + '口红，手指把唇缘晕染模糊。',
      ],
      avoid: [
        p.undertone === '冷调' ? '冷调肤色腮红 / 唇色避开暖橘、蜜桃暖调，选豆沙 / 浆果系更显白。' : '暖调肤色可大胆用蜜桃 / 暖橘腮红。',
      ],
      focus: (p.emphasisOverride && p.emphasisOverride[stepNo]) || em.lip,
    }
  },
  '06': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '中度深色眼影（暖棕 / 红棕）用中号刷从外眼角后 1/3 向眼中间晕染，下眼睑后半段一笔带过。',
        '小号扁头刷蘸最深深棕色贴睫毛根部加深，打造天然阴影感。',
        '指腹蘸微闪珠光点涂在黑眼球正上方，小刷子点眼头 + 卧蚕，点亮双眼。',
      ],
      avoid: [
        '眼影每次蘸取后必须在手背敲几下抖掉余粉再上眼，否则颜色太重还会弄脏干净底妆。',
        p.eyeShape === '杏眼' ? '杏眼眼尾后 1/3 加深即可，别全眼铺深色。' : '圆眼可稍向眼尾外延拉长。',
      ],
      focus: (p.emphasisOverride && p.emphasisOverride[stepNo]) || em.eye,
    }
  },
  '07': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '黑色 / 深棕眼线胶笔：单手提拉眼皮填满睫毛根部空隙（内眼线），顺眼尾自然延伸拉 3-5mm 线条（外眼线），尾部收尖。',
        '睫毛夹按「根部-中部-梢部」三段式夹翘，睫毛膏从根部以 Z 字形往上刷，结块立刻用睫毛梳梳开。',
      ],
      avoid: [
        '不要盲目画夸张猫眼眼线，平视镜子顺下眼睑延伸线自然拉出最不易翻车。',
      ],
      focus: em.eye,
    }
  },
  '08': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        '选灰棕色（不带红调）修容：斜角刷从发际线向内顺颧骨下方斜扫（不超黑眼球垂直线），下颌线从耳根向前扫收双下巴。',
        '小号鼻影刷从眉头下方顺山根两侧画弧线，鼻头画微「V」字定型；哑光高光涂泪沟、法令纹、鼻梁、面中让凹陷嘭起。',
      ],
      avoid: [
        '鼻梁别画两条直线从眉头到鼻尖，会生硬死板；山根鼻头分段修容中间留白最自然。',
        p.faceShape === '鹅蛋脸' ? '鹅蛋脸修容很轻即可，主要提立体不需瘦脸。' : '圆脸修容可略加强两颊收边。',
      ],
      focus: em.base,
    }
  },
  '09': (p, scene, stepNo) => {
    const em = (p.emphasisOverride && p.emphasisOverride[stepNo]) || sceneEmphasis(scene)
    return {
      detail: [
        `纸巾压掉原色口红，换上高饱和'${p.lipPref} / 正红 / 复古红棕'，先涂嘴唇内侧再用唇刷向外晕染，精细勾勒唇峰嘴角显饱满。`,
        '全妆完成：定妆喷雾举在距脸 15-20cm，闭眼呈「X 型 + T 型」均匀洒，自然风干锁全天。',
      ],
      avoid: [
        '深色口红若嘴角显脏，用美妆蛋余粉轻按嘴角修饰干净再走。',
        scene === '晚宴' || scene === '约会' ? '这个场合唇妆是主角，选最浓郁那支。' : '日常场合唇妆点到为止即可。',
      ],
      focus: em.lip,
    }
  },
}

// —— 商品库（按维度组，可接后端） ——
const PRODUCTS = {
  skincare: { title: '妆前保养单品', subtitle: '基于你的肤质 + 场景筛出', items: [ { emoji: '💧', name: '清爽保湿水', brand: 'CeraVe · 湿敷水', match: '93%' }, { emoji: '🧴', name: '分区护理精华', brand: '娇韵诗 · 双萃', match: '90%' } ] },
  primer: { title: '防晒 + 隔离单品', subtitle: '基于「肤色 + 场景持妆」筛出', items: [ { emoji: '☀️', name: '冷调防晒乳 SPF50', brand: '理肤泉 · 大哥大', match: '92%' }, { emoji: '🟣', name: '紫色提亮隔离', brand: 'RMK · 紫', match: '88%' } ] },
  base: { title: '底妆 + 遮瑕单品', subtitle: '基于「混合皮 + 冷调 10N」筛出', items: [ { emoji: '🧴', name: '冷调光泽粉底液 10N', brand: 'NARS · 光透', match: '91%' }, { emoji: '✋', name: '精准遮瑕膏', brand: 'MAC · 冷调遮瑕', match: '89%' } ] },
  brow: { title: '眉毛单品', subtitle: '基于「野生眉 + 冷调自然色」筛出', items: [ { emoji: '🪮', name: '透明野生眉梳', brand: '卡诗 · 眉胶', match: '94%' }, { emoji: '✏️', name: '冷调灰棕眉笔', brand: '植村秀 · 灰棕', match: '90%' } ] },
  'nude-lip': { title: '裸色唇单品', subtitle: '基于「浆果偏好 + 低调」筛出', items: [ { emoji: '💄', name: '豆沙玫瑰唇釉', brand: 'into you · M204', match: '93%' } ] },
  eye: { title: '眼影进阶单品', subtitle: '基于「杏眼 + 冷调」筛出', items: [ { emoji: '🎨', name: '深大地色眼影盘', brand: '3CE · 冷调盘', match: '90%' }, { emoji: '✨', name: '珠光提亮笔', brand: 'Fenty · Cool', match: '85%' } ] },
  liner: { title: '眼线 + 睫毛单品', subtitle: '基于「定型眼神」筛出', items: [ { emoji: '🖊️', name: '深棕眼线液笔', brand: 'KATE · 深棕', match: '91%' }, { emoji: '🪥', name: '浓密睫毛膏', brand: 'Kiss Me · 黑棕', match: '89%' } ] },
  contour: { title: '修容 + 高光单品', subtitle: '基于「鹅蛋脸 + 缎光」筛出', items: [ { emoji: '🪞', name: '冷调修容盘', brand: 'NARS · 缎光', match: '92%' }, { emoji: '✨', name: '缎光高光笔', brand: 'MAC · 冷香槟', match: '88%' } ] },
  'red-lip': { title: '惊艳唇单品', subtitle: '基于「冷白皮 + 场景」筛出', items: [ { emoji: '💄', name: '正红唇釉', brand: 'MAC · Cherry Red', match: '94%' }, { emoji: '🍷', name: '复古红棕唇泥', brand: '酵色 · 梅红', match: '91%' } ] },
}


function buildSteps(profileObj, sceneKey) {
  const p = profileObj
  const s = sceneKey
  return STEP_FRAME.map((f) => {
    const r = detailEngine[f.no](p, s, f.no)
    return {
      ...f,
      detail: r.detail,
      avoid: r.avoid,
      focus: r.focus,
    }
  })
}

// 将 AI 返回的 stepByStep 合并到 9 步骨架
// AI stepByStep 字段：[{ step:"01", title:"妆前保养", description:"...", timeEstimate:"3分钟", difficultyHint:"低" }]
// 本地引擎兜底：AI 没有对应步骤时，用 detailEngine 的结果
function buildStepsWithAI(profileObj, sceneKey, aiContent) {
  const p = profileObj;
  const s = sceneKey;
  const ai = (aiContent && Array.isArray(aiContent.stepByStep)) ? aiContent.stepByStep : [];
  // 按 step 号建立索引
  const aiMap = {};
  ai.forEach((item, idx) => {
    const no = String(item.step || item.no || idx + 1).padStart(2, "0");
    aiMap[no] = item;
  });
  return STEP_FRAME.map((f) => {
    const local = detailEngine[f.no](p, s, f.no);
    const aiItem = aiMap[f.no];
    if (aiItem && aiItem.description) {
      // AI 有该步骤：用 AI 的 title/description，本地引擎补 avoid/focus
      const detail = [aiItem.description];
      // AI 可能返回多条
      if (Array.isArray(aiItem.detail)) detail.push(...aiItem.detail.filter(Boolean));
      return {
        ...f,
        name: aiItem.title || f.name,
        detail,
        avoid: local.avoid,
        focus: local.focus,
        time: aiItem.timeEstimate || f.time,
        difficulty: aiItem.difficultyHint || f.difficulty,
      };
    }
    // AI 没有该步骤：纯本地兜底
    return { ...f, detail: local.detail, avoid: local.avoid, focus: local.focus };
  });
}

// 将 AI 返回的 productRecs 转为弹窗商品数据（与本地 PRODUCTS 结构兼容）
// productRecs: { base:[{name,reason,price,imageUrl?,itemUrl?}], eyes:[...], lips:[...], cheeks:[...] }
// 映射到本地 group key: base→base, eyes→eye, lips→red-lip(nude-lip if phase1), cheeks→nude-lip
function buildProductsFromAI(aiContent) {
  const recs = (aiContent && aiContent.productRecs) || {};
  const out = {};
  const DIM_MAP = {
    base: { title: "底妆单品", subtitle: "基于你的肤质 + 场景筛出", emoji: "🧴" },
    eyes: { title: "眼妆单品", subtitle: "基于你的眼型 + 场景筛出", emoji: "🎨" },
    lips: { title: "唇妆单品", subtitle: "基于你的唇色偏好筛出", emoji: "💄" },
    cheeks: { title: "腮红单品", subtitle: "基于你的肤色筛出", emoji: "🌸" },
  };
  for (const [key, meta] of Object.entries(DIM_MAP)) {
    const items = recs[key];
    if (Array.isArray(items) && items.length > 0) {
      out[key] = {
        title: meta.title,
        subtitle: meta.subtitle,
        items: items.map((it) => ({
          emoji: it.imageUrl ? "🛍️" : meta.emoji,
          name: it.name || "",
          brand: it.shopTitle ? (it.brand ? it.brand + " · " + it.shopTitle : it.shopTitle) : (it.brand || ""),
          match: it.match || "",
          price: it.price || "",
          itemUrl: it.itemUrl || null,
          imageUrl: it.imageUrl || null,
          _priceIsRef: it._priceIsRef || false,
        })),
      };
    }
  }
  return out;
}

function calcPhaseTotals(profile) {
  const base = { p1: 12, p2: 9 };
  let p1 = base.p1, p2 = base.p2;
  const level = profile.skillLevel || "";
  if (level.includes("新手")) { p1 = Math.round(p1 * 1.5); p2 = Math.round(p2 * 1.5); }
  else if (level.includes("熟练") || level.includes("进阶")) { p1 = Math.round(p1 * 0.7); p2 = Math.round(p2 * 0.7); }

  const time = profile.timeBudget || "";
  if (time.includes("5分钟") || time.includes("极简")) {
    // 极简模式：阶段二只保留 09（唇妆焦点），约 4 分钟
    p2 = 4;
  } else if (time.includes("30分钟") || time.includes("精致")) {
    p1 = p1 + 2; // 多留 2 分钟精修
    p2 = p2 + 3; // 二次定妆 + 细节补妆
  }
  return { p1, p2 };
}


const GROUP_TO_DIM = {
  base: "base",
  primer: "base",
  skincare: "base",
  brow: "base",
  eye: "eyes",
  liner: "eyes",
  "nude-lip": "lips",
  "red-lip": "lips",
  contour: "cheeks",
};

export { SCENES, STEP_FRAME, detailEngine, PRODUCTS, buildSteps, buildStepsWithAI, buildProductsFromAI, calcPhaseTotals, GROUP_TO_DIM }
